import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { getParentUrl } from '../../utils/browser';
const usePostMessage = () => {
  const [subject, setSubject] = useState([]);
  const [parsedMessage, setParsedMessage] = useState({});

  const history = useHistory();
  const validPaths = ['/documents', '/programs', '/reports'];

  const sendMessage = message => {
    window.parent.postMessage(
      { message: JSON.stringify(message) },
      getParentUrl()
    );
  };

  const onMessage = event => {
    if (event.origin === getParentUrl()) {
      try {
        let parsedMessage = [];

        if (typeof event.data?.message === 'string') {
          parsedMessage = JSON.parse(event.data.message);
        } else if (Array.isArray(event.data?.message)) {
          parsedMessage = event.data.message;
        } else {
          throw new Error('Message is not in expected format');
        }

        const subjectValue = parsedMessage.find(
          item => item.key === 'subject'
        )?.value;
        setSubject(subjectValue);
        setParsedMessage(parsedMessage);
        processMessage(parsedMessage);
      } catch (error) {
        console.error('Invalid JSON received:', event.data, error);
      }
    }
  };
  const processMessage = parsedMessage => {
    if (typeof parsedMessage !== 'undefined') {
      let subjectValue = Array.isArray(parsedMessage)
        ? parsedMessage.find(item => item.key === 'subject')?.value
        : undefined;
      if (subjectValue === 'undefined') {
        subjectValue = subject;
      }

      if (subjectValue === 'unauthorized') {
        setLocalStorage(parsedMessage);
      }
      if (subjectValue === 'navigateBack') {
        const currentPath = history.location.pathname;

        const basePath = validPaths.find(base =>
          currentPath.startsWith(base + '/')
        );

        if (basePath && currentPath !== basePath) {
          history.push(basePath);
        }
      }
    }
  };

  const setLocalStorage = data => {
    if (localStorage.getItem('processedUnauthorized') === 'true') {
      return;
    }
    localStorage.clear();
    if (Array.isArray(data)) {
      data.forEach(item => {
        localStorage.setItem(item.key, item.value);
      });
    }
    window.location.reload();
    localStorage.setItem('processedUnauthorized', 'true');
  };

  const addEventListener = (event, callback) => {
    window.addEventListener('message', onMessage);
  };

  const removeEventListener = (event, callback) => {
    window.removeEventListener('message', onMessage);
  };

  const removeHelperVariables = () => {
    localStorage.removeItem('processedUnauthorized');
    localStorage.removeItem('subject');
  };

  return {
    parsedMessage,
    removeHelperVariables,
    sendMessage,
    addEventListener,
    removeEventListener,
    processMessage
  };
};

export default usePostMessage;
